import React from 'react';

import './About.css';
import Header2 from '../../components/header/Header2';
import HeroSectionAbout from '../../components/hero_section_about_us/HeroSectionAbout';
import OurVision from '../../components/our_vision/OurVision';
import OurMission from '../../components/our_mission/OurMission';
import OurCoreService from '../../components/our_core_services/OurCoreService';
import WhyChooseUs from '../../components/why_choose_us/WhyChooseUs';
import CallToActionAbout from '../../components/call_to_action_about/CallToActionAbout';
import Footer from '../../components/footer/Footer';
import { Helmet } from "react-helmet";
export default function About() {
  return (
    <>
    <Helmet>
  <title>
    About Us | GlassHopeOne Technologies Pvt. Ltd. – Enterprise Software & SaaS Company
  </title>

  <meta
    name="description"
    content="Learn about GlassHopeOne Technologies Pvt. Ltd., a technology-driven company specializing in enterprise software, SaaS platforms, and scalable web and mobile applications. We help businesses innovate, transform, and grow in a digital-first world."
  />

  <meta
    name="keywords"
    content="about GlassHopeOne Technologies, enterprise software company, SaaS solutions provider, application development company, IT services company India, GlassHopeOne"
  />

  <meta name="author" content="GlassHopeOne Technologies Pvt. Ltd." />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />

  <link rel="canonical" href="https://www.glasshopeone.com/about-us" />
</Helmet>

    <Header2/>
    <HeroSectionAbout/>
    <OurVision/>
    <OurMission/>
    <OurCoreService/>
    <WhyChooseUs/>
    <CallToActionAbout/>
    <Footer/>
    </>
  )
}
